import { AxiosResponse } from "axios";
import { useCallback, useState } from "react";

import { useAxiosClient } from "@/hooks";
import { CreateShareRequest } from "@/types/requests";
import { CreateShareResponse } from "@/types/responses";

const useShareStudy = (studyId: string) => {
  const [error, setError] = useState<string | null>(null);
  const [link, setLink] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const client = useAxiosClient(`/studies/${studyId}/share`);

  const shareStudy = useCallback(
    async (expiresInDays: number) => {
      setError(null);
      setLink(null);
      setLoading(true);

      try {
        const response = await client.post<
          CreateShareResponse,
          AxiosResponse<CreateShareResponse>,
          CreateShareRequest
        >("", {
          expires_in_days: expiresInDays,
        });
        setLink(response.data.link);
        return response.data.link;
      } catch (e) {
        setError(e instanceof Error ? e.message : String(e));
        return null;
      } finally {
        setLoading(false);
      }
    },
    [client]
  );

  return {
    error,
    link,
    loading,
    shareStudy,
  };
};

export { useShareStudy };
